import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import About from './pages/About/index';
import Discover from './pages/Discover/Discover';
import Auth from './pages/Auth/Auth';
import Profile from './pages/Profile/Profile';
import Studio from './pages/Studio/Studio';
import StudioIndustries from './pages/Studio/StudioIndustries';
import Transactions from './pages/transactions/Transactions';
import Settings from './pages/Settings/Settings';
import EditProfile from './pages/Profile/EditProfile';
import TrialDetail from './pages/TrialSubmissions/TrialDetail';
import TrialSubmissions from './pages/TrialSubmissions/TrialSubmissions';
import BusinessPlan from './pages/BizPlan/BusinessPlanPage';
import './styles/global.css';
import './styles/components.css';

import Messages from './pages/Messages/Messages';
import SystemMessages from './pages/Messages/SystemMessages';
import { TagPlayground } from './pages/Tags/TagPlayground';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import EngineContinuePage from './pages/Auth/EngineContinuePage';

// Contracts (V2 model — coverage-driven payments, project-type split,
// 3-reason revisions, e签宝 signing, acceptance-period auto-accept).
import { ContractsProvider } from './pages/Contracts/ContractsContext';
import ContractsListPage from './pages/Contracts/ContractsListPage';
import ContractDetailPage from './pages/Contracts/ContractDetailPage';
import ContractCreatePage from './pages/Contracts/ContractCreatePage';
import MyContractsPage from './pages/Contracts/MyContractsPage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/business-plan" element={<BusinessPlan />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/auth/engine/continue" element={<ProtectedRoute><EngineContinuePage /></ProtectedRoute>} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/studio/industries" element={<StudioIndustries />} />
          <Route path="/official" element={<Navigate to="/studio" replace />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/profile/:id/me" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/profile/edit" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
          <Route path="/trials" element={<ProtectedRoute><TrialSubmissions /></ProtectedRoute>} />
          <Route path="/trials/:id" element={<ProtectedRoute><TrialDetail /></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/messages/:id" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/system-messages" element={<ProtectedRoute><SystemMessages /></ProtectedRoute>} />
          <Route path="/system-messages/:id" element={<ProtectedRoute><SystemMessages /></ProtectedRoute>} />
          <Route path="/tag-playground" element={<TagPlayground />} />

          {/* Contracts — V2 model. Provider wraps the subtree so the
              local write-through cache survives navigation between
              list / new / detail. */}
          <Route path="/contracts/*" element={
            <ProtectedRoute>
              <ContractsProvider>
                <Routes>
                  <Route index element={<ContractsListPage />} />
                  <Route path="new" element={<ContractCreatePage />} />
                  <Route path=":id" element={<ContractDetailPage />} />
                </Routes>
              </ContractsProvider>
            </ProtectedRoute>
          } />

          {/* 我的合同 — read-only contract records (view/print/download PDF). */}
          <Route path="/my-contracts" element={
            <ProtectedRoute>
              <ContractsProvider>
                <MyContractsPage />
              </ContractsProvider>
            </ProtectedRoute>
          } />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
